<template>
  <svg
    color="transparent"
    class="mx-auto"
    xmlns="http://www.w3.org/2000/svg"
    width="2em"
    height="2em"
    viewBox="0 0 24 24"
  >
    <g stroke="#16a34a" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
      <circle cx="12" cy="12" r="9" fill="transparent" fill-opacity="0">
        <animate fill="freeze" attributeName="fill-opacity" begin="0.18s" dur="0.135s" values="0;0.3" />
      </circle>
      <path fill="none" stroke-dasharray="14" stroke-dashoffset="14" d="M8 12L11 15L16 10">
        <animate fill="freeze" attributeName="stroke-dashoffset" dur="0.18s" values="14;0" />
      </path>
    </g>
  </svg>
</template>
